import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LogsService } from 'src/app/services/logs/logs.service';

@Component({
  selector: 'app-logs',
  imports: [CommonModule, FormsModule],
  templateUrl: './logs.component.html',
  styleUrl: './logs.component.css'
})

export class LogsComponent implements OnInit {
  logs: any[] = [];
  pagination: any;

  // filters for UI
  filters = {
    per_page: 20,
    success: '',
    action: '',
    entity: '',
    search: '',
  };

  isLoading = false;

  constructor(private logsService: LogsService) {}

  ngOnInit(): void {
    this.loadLogs(1);
  }

  loadLogs(page = 1) {
    this.isLoading = true;

    this.logsService.getLogs({
      page,
      ...this.filters,
    }).subscribe({
      next: (res) => {
        // expecting: { status: 'success', data: LaravelPaginator }
        this.logs = res?.data?.data ?? [];
        this.pagination = res?.data ?? null;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  applyFilters() {
    this.loadLogs(1);
  }

  clearFilters() {
    this.filters = {
      per_page: 20,
      success: '',
      action: '',
      entity: '',
      search: '',
    };
    this.loadLogs(1);
  }

  goTo(page: number) {
    if (!this.pagination) return;
    if (page < 1 || page > (this.pagination.last_page ?? 1)) return;
    this.loadLogs(page);
  }
}
